export enum TemperatureProfileMaterialisationOptions {
    Basic,
    WithHistories
}
